import { useState } from "react";
import NeedReferral from "../components/Referral/NeedReferral";
import GiveReferral from "../components/Referral/GiveReferral";
import Seo from "../components/Generic/Seo";
import GoogleAnalytics from "../components/Generic/GoogleAnalytics";

const Referral = () => {
  const [activeTab, setActiveTab] = useState("give"); // default to "give"

  const seoData = {
    title: "WiSE Referral Program — Find & Give Referrals",
    description:
      "Search for referral opportunities or offer help to others in the WiSE network. Connect, collaborate, and grow the Women in Semiconductor community.",
    keywords:
      "WiSE referral, referral network, women in semiconductor, give referral, need referral, professional network",
    pathSlug: "referral",
  };

  return (
    <>
      <Seo data={seoData} />
      <GoogleAnalytics page={seoData.pathSlug} title={seoData.title} />

      <div className="container my-5">
        <h1 className="referral-title">Refer. Empower. Grow Together. </h1>

          <p className="referral-description">
             The WiSE Referral Program is your way to help more women discover opportunities in 
             semiconductors and electronics. By referring fellow WiSE members to open roles, you help 
             build a stronger, more inclusive semiconductor ecosystem.Every referral helps grow a 
             community built on support, knowledge, and collective success. 
          </p>
          
        {/* Custom Tab Buttons */}
        <div className="d-flex justify-content-start mb-4 gap-3">
          <button
            className={`btn me-2 rounded-pill ${
              activeTab === "give" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("give")}
          >
            I Can Give Referral
          </button>
          <button
            className={`btn rounded-pill ${
              activeTab === "need" ? "btn-primary" : "btn-outline-primary"
            }`}
            onClick={() => setActiveTab("need")}
          >
            I Need Referral
          </button>
        </div>


        {/* Render Active Tab Content */}
        {activeTab === "give" && <GiveReferral />}
        {activeTab === "need" && <NeedReferral />}
      </div>
    </>
  );
};

export default Referral;
